import React, { PureComponent } from 'react';
import { withStyles } from '@mui/styles';

import CommonStyles from '../../common/CommonStyles';

import Stimul from './components/Stimul';

import Button from '@mui/material/Button';

// You can import the default tree with dnd context
import SortableTree from 'react-sortable-tree-patch-react-17';

const styles = {
  itemContainer: {
    padding: '10px 10px 3px 0',
    height: '100%',
    boxSizing: 'border-box',
  },
  itemContainerInner: {
    position: 'relative',
    height: '100%',
    border: 'solid #bbb 1px',
    boxShadow: '0 2px 2px -2px',
    padding: '0 5px 0 10px',
    borderRadius: '2px',
    minWidth: '230px',
    MsFlex: '1 0 auto',
    flex: '1 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
  },
  ...CommonStyles,
};

class StimulView extends PureComponent {
  state = {
    btnsTypes: [],
    editNewFlow: false,
    editNewFlowName: '',
    addNewStimul: false,
    flows: [],
    categories: [],
    stimulsTypes: [],
    deleteModalFlowIndex: null,
    isDeleteModalOpened: false,
    flow: {
      stimuls: [],
    },
    stimulsMap: [],
    defaultPositions: {},
    treeData: [],
    loaded: false,
  };

  UNSAFE_componentWillMount() {
    const { flow } = this.props;
    const { treeData } = this.state;

    if (flow.stimuls) {
      flow.stimuls.forEach((stml) => {
        const stmlWithChildren = this.buildStmlData(flow, stml);

        treeData.push(stmlWithChildren);
      });
    }

    this.setState({ flow, treeData }, () => {
      const { flow } = this.state;

      flow.stimuls.forEach((stml) => {
        this.removeDuplicates(flow, stml);
      });

      this.setState({ loaded: true });
    });
  }

  buildStmlData = (flow, stml) => {
    const stmlObj = {
      title: `stimul: ${stml.text}`,
      children: [],
      type: 'stml',
      stimul: stml,
      expanded: true,
    };

    if (stml.evoked_stimul) {
      const ev_stml = flow.stimuls.find((fStml) => fStml.id === stml.evoked_stimul);

      if (stml.evoked_stimul) {
        const res = this.buildStmlData(flow, ev_stml);
        stmlObj.children.push(res);
      }
    }

    if (stml.buttons) {
      stml.buttons.forEach((btn) => {
        const btnData = {
          title: `btn: ${btn.title}`,
          children: [],
          type: 'btn',
          expanded: true,
        };

        if (btn.evoked_stimul) {
          const ev_stml = flow.stimuls.find((stml) => stml.id === btn.evoked_stimul);

          const evStmlWithChildren = this.buildStmlData(flow, ev_stml);

          btnData.children.push(evStmlWithChildren);
        }

        stmlObj.children.push(btnData);
      });
    }

    return stmlObj;
  };

  removeDuplicates = (flow, stml) => {
    const stmlObj = {
      title: `stimul: ${stml.text}`,
      children: [],
      type: 'stml',
      stimul: stml,
      expanded: true,
    };

    if (stml.evoked_stimul) {
      const ev_stml = flow.stimuls.find((fStml) => fStml.id === stml.evoked_stimul);

      const ev_stml_index = flow.stimuls.findIndex((fStml) => fStml.id === stml.evoked_stimul);

      if (stml.evoked_stimul) {
        const { treeData } = this.state;

        treeData.splice(ev_stml_index, 1);

        this.setState({ treeData }, () => {
          const res = this.removeDuplicates(flow, ev_stml);

          stmlObj.children.push(res);
        });
      }
    }

    if (stml.buttons) {
      stml.buttons.forEach((btn) => {
        const btnData = {
          title: `btn: ${btn.title}`,
          children: [],
          type: 'btn',
          expanded: true,
        };

        if (btn.evoked_stimul) {
          const ev_stml = flow.stimuls.find((stml) => stml.id === btn.evoked_stimul);

          const ev_stml_index = flow.stimuls.findIndex((stml) => stml.id === btn.evoked_stimul);

          const { treeData } = this.state;

          treeData.splice(ev_stml_index, 1);

          this.setState({ treeData }, () => {
            const evStmlWithChildren = this.removeDuplicates(flow, ev_stml);

            btnData.children.push(evStmlWithChildren);
          });
        }

        stmlObj.children.push(btnData);
      });
    }

    return stmlObj;
  };

  nodeContentRenderer = (node) => {
    const { classes, pidsData } = this.props;

    return (
      <div
        style={{
          height: '100%',
        }}
      >
        <div className={classes.itemContainer}>
          <div
            className={classes.itemContainerInner}
            style={{
              background: `${node.type === 'btn' ? '#e8eff9' : ''}`,
            }}
          >
            {node.type === 'stml' ? (
              <Stimul stimul={node.stimul} classes={classes} pidsData={pidsData} />
            ) : node.type === 'btn' ? (
              <Button size="small" variant="contained" color="primary">
                {node.title}
              </Button>
            ) : node.type === 'evoked_stml' ? (
              <Stimul stimul={node.ev_stml} classes={classes} pidsData={pidsData} />
            ) : (
              <div>Illegal type</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { treeData, loaded } = this.state;

    return (
      <div style={{ height: 'calc(100vh - 96px)' }}>
        {loaded ? (
          <SortableTree
            canDrag={false}
            treeData={treeData}
            onChange={(treeData) => this.setState({ treeData })}
            nodeContentRenderer={(params) => this.nodeContentRenderer(params.node)}
          />
        ) : (
          <p>Loading</p>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(StimulView);
